import { ICityMastDropdown, IClientCompanyDropdown, IEndClientsDropdown, IStateMastDropdown } from "./IDropdown";
export enum Req_Type {
    Normal = 1,
    Tough = 2
}

export enum Req_Priority {
    Low = 1,
    High = 2,
    VeryHigh = 3
}

export enum Req_Term {
    NotMentioned = 0,
    Contract = 1,
    ContractToHire = 2,
    Permanent = 3
}

export enum Job_Type {
    NotMentioned = 0,
    Onsite = 1,
    Hybrid = 2,
    Remote = 3
}

export enum Interview_Process {
    NotMentioned = 0,
    F2F = 1,
    InPerson = 2,
    Skype = 3,
    SkypeAndF2F = 4,
    TelSkypeAndF2F = 5,
    TelSparkHire = 6,
    TelWebex = 7,
    TelZoom = 8,
    TeleAndF2F = 9,
    Telephonic = 10,
    TelephonicAndF2F = 11
}

export enum Publish_Type {
    Normal = 0,
    Skill = 1,
    Branch = 2,
    Company = 3,
    Globally = 4
}
export enum Mode_Of_Req {
    Portal = 1,
    Mail = 2,
    Other = 3,
}
export enum Client_Type {
    Direct_Client = 1,
    Implementing_Partner = 2
}

export interface IRequirementMast {
    req_ID?: number,
    pV_Contact_PersonID?: number,
    req_Job_Title?: string,
    req_Duration?: string,
    req_Term?: Req_Term,
    req_NoOfPositions?: string,
    req_NoOfResumePerPositions?: number,
    req_Category?: number,
    req_Priority?: Req_Priority,
    req_InterviewProcess?: Interview_Process,
    req_RequiredSkill?: string,
    req_JobDescription?: string,
    req_Type?: Req_Type,
    job_Type?: Job_Type,
    pV_Contact_PersonID_Name?: string,
    pV_Contact_PersonID_Email?: string,
    vendor_Company_ID?: number,
    vendor_Company_Name?: string,
    client_company?: IClientCompanyDropdown,
    req_City?: number,
    city_Name?: string,
    city?: ICityMastDropdown,
    req_State?: number,
    state_Name?: string,
    state?: IStateMastDropdown,
    req_Country?: number,
    req_Rate?: string,
    endClient_ID?: number,
    req_EndClient?: string,
    endClient?: IEndClientsDropdown,
    req_Category_Name?: string,
    req_isDirectClientRequirement?: string,
    client_Communication?: string,
    req_PostedBySalesManager?: number,
    req_PostedBySalesManager_Name?: string,
    req_PostedDateAndTime?: Date,
    req_EditedBy?: number,
    req_EditDateAndTime?: Date,
    req_Hold_UnHoldStatus?: boolean,
    req_Hold_unHoldDateTime?: Date,
    req_AllocatedDateTime?: Date,
    req_Allocated_By?: number,
    req_Service_Status?: string,
    req_Publish_Status?: string,
    req_ECI_Status?: number,
    req_PO_Status?: number,
    reqType?: number,
    visa?: string,
    industry_Id?: number,
    industry_Name?: string,
    reqType_Name?: string,
    travelReq?: string,
    teamName?: number,
    additional_info?: string,
    pOC_Transfer_Req?: number,
    pOC_Tnf_Req_Acpt_By?: number,
    mode_Of_Req?: Mode_Of_Req,
    mode_Of_Req_Comment?: string,
    req_Sub_Category?: number,
    req_Sub_Category_Name?: string,
    special_Constraint?: string,
    req_id?: number,
    max_Submission?: number,
    no_Auto_Allocation?: boolean,
    createdAt?: Date,
    email_Message_ID?: string,
    is_POC_Post?: boolean,
    clientType_ID?: number,
    client_Type?: number,
    email_ID?: number
}